import type {
	ReviewTemplateResponse as ReviewTemplateV2ApiResponse,
	ReviewTemplateWithNames,
} from "@performyard/service-contracts";

import internalRequest from "./internal-api/internal-base-request";

export type { ReviewTemplateWithNames, TemplateFormAssignmentWithNames } from "@performyard/service-contracts";

/**
 * v2: `GET /v1/reviews/review-templates/:templateId`. Returns the template with form
 * names and resolved participant names baked into `formAssignments`.
 */
export const fetchReviewTemplateV2 = async (templateId: string): Promise<ReviewTemplateWithNames> => {
	const [response] = await internalRequest<ReviewTemplateV2ApiResponse>(`/v1/reviews/review-templates/${templateId}`);
	return response.data;
};
